import api from "./api";


export interface Insight {
  tipo: string;
  titulo: string;
  descricao: string;
  categoria: string;
  prioridade: number;
  recomendacoes: string[];
  fonte: string;
  dataGeracao: string;
}

export interface InsightResponse {
  insights: Insight[];
  resumoExecutivo: string;
  totalInsights: number;
  dataGeracao: string;
}

export interface InsightRequest {
  empresaId?: string;
  categorias?: string[];
  incluirRecomendacoes?: boolean;
}

class InsightsService {
  async gerarInsights(empresaId: string, request?: InsightRequest): Promise<InsightResponse> {
    try {
      console.log(`Gerando insights para empresa ${empresaId}`, { request });
      const response = await api.post(`/api/insights/${empresaId}`, request || {});
      console.log('Insights gerados com sucesso:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('Erro ao gerar insights:', error);
      
      if (error.response?.status === 401) {
        throw new Error('Não autorizado. Verifique se você está logado.');
      } else if (error.response?.status === 404) {
        throw new Error('Empresa não encontrada.');
      } else if (error.response?.status === 500) {
        const errorMsg = error.response?.data?.message || error.response?.data || error.message;
        if (typeof errorMsg === 'string' && errorMsg.includes('Gemini')) {
          throw new Error('Erro na configuração do Gemini. Verifique se a API key está configurada no backend.');
        }
        throw new Error('Erro interno do servidor. Verifique os logs do backend.');
      } else if (error.code === 'NETWORK_ERROR' || !error.response) {
        throw new Error('Erro de conexão. Verifique se o backend está rodando.');
      }
      
      throw new Error(error.response?.data?.message || error.message || 'Erro ao gerar insights.');
    }
  }

  async listarCategorias(empresaId: string): Promise<string[]> {
    try {
      const response = await api.get(`/api/insights/${empresaId}/categorias`);
      return response.data;
    } catch (error) {
      console.error('Erro ao listar categorias:', error);
      return [];
    }
  }

  async listarTipos(empresaId: string): Promise<string[]> {
    try {
      const response = await api.get(`/api/insights/${empresaId}/tipos`);
      return response.data;
    } catch (error) {
      console.error('Erro ao listar tipos:', error);
      return [];
    }
  }
}

export const insightsService = new InsightsService();
